/* ===== EPD 3D BG Connect v2 (2026-09-08) =====
   דואג שההדמיה התלת-ממדית למעלה תציג את התמונה המעובדת (ללא רקע).

   מה היה שבור: הגרסה הקודמת העבירה ל-3D רק כתובות שמכילות 'fal.'.
   התמונות של הלקוחות יושבות בקלאודינרי, ולכן התנאי לעולם לא התקיים,
   וההדמיה המשיכה להציג את הקובץ המקורי עם הרקע שלו.
   עכשיו כל כתובת מועברת, וההדמיה מתעדכנת בכל פעם ש-D.durl משתנה. */
(function(){
  var lastF='', lastB='';

  function loadInto(url, side){
    var im=new Image();
    im.crossOrigin='anonymous';
    im.onload=function(){
      if(typeof window.epd3dSetDesign==='function'){ window.epd3dSetDesign(side, im); return; }
      if(side==='f' && typeof window.frontImg!=='undefined'){ window.frontImg=im; }
      if(side==='b' && typeof window.backImg!=='undefined'){ window.backImg=im; }
      if(typeof window.epd3dRedraw==='function'){ window.epd3dRedraw(); }
    };
    im.onerror=function(){};
    im.src=url;
  }

  function tick(){
    try{
      var D=window.D; if(!D) return;
      if(D.durl && D.durl!==lastF && D.durl.indexOf('http')===0){
        lastF=D.durl; loadInto(D.durl,'f');
      }
      if(D.durlB && D.durlB!==lastB && D.durlB.indexOf('http')===0){
        lastB=D.durlB; loadInto(D.durlB,'b');
      }
    }catch(e){}
  }
  setInterval(tick, 500);
})();
